import { render, staticRenderFns } from "./puDialog_component.vue?vue&type=template&id=8ed1a57a&"
import script from "./puDialog_component.vue?vue&type=script&lang=js&"
export * from "./puDialog_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports